import { createTheme } from '@mui/material';
import {} from '@mui/material/colors';
import './App.css';

declare module '@mui/material/styles' {
	interface TypographyVariants {
		regular: React.CSSProperties;
		medium: React.CSSProperties;
		bold: React.CSSProperties;
	}

	// allow configuration using `createTheme`
	interface TypographyVariantsOptions {
		regular?: React.CSSProperties;
		medium?: React.CSSProperties;
		bold?: React.CSSProperties;
	}
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
	interface TypographyPropsVariantOverrides {
		regular: true;
		medium: true;
		bold: true;
	}
}

declare module '@mui/material/Chip' {
	interface ChipPropsColorOverrides {
		chipTertiary: true;
		chipPrimary: true;
		chipGreen: true;
		chipRed: true;
		chipGrey: true;
		chipLightGrey: true;
		chipFilledTertiary: true;
		chipPIRUser: true;
		chipCloth: true;
		chipFood: true;
		chipLive: true;
		chipWalk: true;
		chipCommunityWelfareInfo: true;
	}
}

declare module '@mui/material/styles/createPalette' {
	interface CommonColors {
		tertiary70: string;
		tertiary90: string;
		neutral20: string;
		neutral30: string;
		neutral40: string;
		neutral50: string;
		neutral70: string;
		neutral90: string;
	}

	interface Palette {
		chipPrimary: Palette['primary'];
		chipTertiary: Palette['primary'];
		chipGreen: Palette['primary'];
		chipRed: Palette['primary'];
		chipGrey: Palette['primary'];
		chipLightGrey: Palette['primary'];
		chipFilledTertiary: Palette['primary'];
		chipPIRUser: Palette['primary'];
		chipCloth: Palette['primary'];
		chipFood: Palette['primary'];
		chipLive: Palette['primary'];
		chipWalk: Palette['primary'];
		chipCommunityWelfareInfo: Palette['primary'];
	}

	interface PaletteOptions {
		chipPrimary?: PaletteOptions['primary'];
		chipTertiary?: PaletteOptions['primary'];
		chipGreen?: PaletteOptions['primary'];
		chipRed?: PaletteOptions['primary'];
		chipGrey?: PaletteOptions['primary'];
		chipLightGrey?: PaletteOptions['primary'];
		chipFilledTertiary?: PaletteOptions['primary'];
		chipPIRUser?: PaletteOptions['primary'];
		chipCloth?: PaletteOptions['primary'];
		chipFood?: PaletteOptions['primary'];
		chipLive?: PaletteOptions['primary'];
		chipWalk?: PaletteOptions['primary'];
		chipCommunityWelfareInfo?: PaletteOptions['primary'];
	}
}

export const mainTheme = createTheme({
	palette: {
		primary: { main: '#1BBED7' },
		chipGreen: { main: '#646D11' },
		error: {
			main: '#FF5B4D',
		},
		background: {
			default: '#faf8f2',
		},
		common: {
			tertiary70: '#E09E36',
			tertiary90: '#FFDDB3',
			neutral20: '#212529',
			neutral30: '#495057',
			neutral40: '#5D5E61',
			neutral50: '#76777A',
			neutral70: '#AAABAE',
			neutral90: '#E2E2E5',
		},
		secondary: {
			main: '#1BBED7',
		},

		// for Chip
		chipPrimary: {
			main: '#E0F7FB',
			light: '#E0F7FB',
			dark: '#E0F7FB',
			contrastText: '#353B02',
		},
		chipTertiary: {
			main: '#F0F7BA',
			light: '#F0F7BA',
			dark: '#F0F7BA',
			contrastText: '#353B02',
		},
	},
	components: {
		MuiTypography: {
			styleOverrides: {
				h4: {
					fontWeight: 700,
				},
			},
		},
		MuiChip: {
			defaultProps: {
				size: 'small',
			},
			styleOverrides: {
				root: ({ ownerState }) => {
					if (ownerState.color === 'default') {
						return {
							backgroundColor: '#E9ECEF',
							color: '#353B02',
							border: 'none',
						};
					}
					if (ownerState.color === 'chipPrimary') {
						return {
							border: 'none',
						};
					}
					if (ownerState.color === 'chipTertiary') {
						return {
							border: 'none',
						};
					}
					return {};
				},
			},
		},
		MuiButton: {
			defaultProps: {
				// sx: {
				// 	textTransform: 'none',
				// },
			},
			styleOverrides: {
				root: {
					textTransform: 'none',
				},
				textPrimary: {
					color: '#1BBED7',
				},
				containedPrimary: {
					backgroundColor: '#4C5403',
					color: '#fff',
					'&:hover': {
						backgroundColor: '#949E39',
					},
					'&.Mui-focused, &.Mui-active': {
						backgroundColor: '#4C5403',
					},
				},
				outlinedInfo: {
					backgroundColor: '#fff',
					color: '#3F3D3C',
					border: '1px solid #D7D7D7',
				},
			},
		},
		MuiIconButton: {
			defaultProps: {},
			styleOverrides: {
				root: {},
				colorPrimary: {
					color: '#4C5403',
				},
			},
		},
	},
});

export default mainTheme;
